import { render, staticRenderFns } from "./receivedPaymentGatewayBalance.vue?vue&type=template&id=167b69ee"
import script from "./receivedPaymentGatewayBalance.vue?vue&type=script&lang=js"
export * from "./receivedPaymentGatewayBalance.vue?vue&type=script&lang=js"
import style0 from "./receivedPaymentGatewayBalance.vue?vue&type=style&index=0&id=167b69ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports